import type { DirectnessFilterState } from './types';

const getPreferDirects = (state: DirectnessFilterState) => state.filtering;

const isPreferDirectsEnabled = (state: DirectnessFilterState) => state.enabled;

const isPreferDirectsOverridden = (state: DirectnessFilterState) =>
  state.initialFiltering !== state.filtering;

export default {
  getPreferDirects,
  isPreferDirectsEnabled,
  isPreferDirectsOverridden,
};
